import type { PropsWithChildren } from 'react';

import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PATH_DASHBOARD } from '../../routes/paths';

type Tab = {
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    label: 'active',
    value: 'active',
  },
  {
    label: 'inactive',
    value: 'inactive',
  },
  {
    label: 'all',
    value: 'all',
  },
];

type ClientListNavigatorContextType = {
  currentTab: string;
  tabs: Tab[];
};

const defaultClientListNavigatorContextValue = {
  currentTab: 'active',
  tabs: defaultTabs,
};

export const ClientListNavigatorContext =
  createContext<ClientListNavigatorContextType>(
    defaultClientListNavigatorContextValue
  );

type ClientListNavigatorContextProviderProps = PropsWithChildren<any>;

export const ClientListNavigatorContextProvider = ({
  children,
}: ClientListNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<ClientListNavigatorContextType>(
      defaultClientListNavigatorContextValue
    );

  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname) {
      let currentTab = pathname
        .replace(`${PATH_DASHBOARD.client.list}`, '')
        .replace('/', '');
      currentTab = currentTab || defaultTabs[0].value;
      setContextValue((prev) => ({ ...prev, currentTab }));
    } else {
      navigate(PATH_DASHBOARD.client.list);
    }
  }, [navigate, pathname]);

  return (
    <ClientListNavigatorContext.Provider value={{ ...contextValue }}>
      {children}
    </ClientListNavigatorContext.Provider>
  );
};

export const useClientListNavigatorContext = () => {
  return useContext(ClientListNavigatorContext);
};
